import Main from './subPages/main';
import Edit from './subPages/edit';

const routes = [
  {
    path: '/*',
    canUse: [],
    Component: Main,
  },
  {
    path: '/:id/edit',
    Component: Edit,
    props: {
      isNew: false,
    },
  },
  {
    path: '/new',
    Component: Edit,
    props: {
      isNew: true,
    },
  },
];

export default routes;
